import handleDSOperation from '../../functions/handleDSOperation'

const onRowDelete = async (oldData) => {
  await handleDSOperation(null, 'delete', oldData.id)
}

export default onRowDelete
